/**
 * Created by Rodrigo Quesada on 09/04/17.
 */
import {NgModule} from '@angular/core';
import {ProfileCompletionService} from './profile-completion.service';

@NgModule({
    providers: [
        ProfileCompletionService
    ]
})
export class ProfileCompletionModule {
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/domain/model/completion/profile-completion.module.ts